var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ui-chip',{staticClass:"selected-facet",attrs:{"label":_vm.facetValue.facetName,"content":_vm.facetValue.value.label},on:{"remove":_vm.remove}})
}
var staticRenderFns = []

export { render, staticRenderFns }